var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.option.style),on:{"click":_vm.fn}},[_c('img',{attrs:{"src":_vm.imgHost + _vm.option.url + '?v=' + _vm.$config.OSSVersion}})])}
var staticRenderFns = []

export { render, staticRenderFns }